export const exportHeaders = [
  {
    label: "Loyalty ID",
    key: "loyalty_id",
  },
  {
    label: "Initial CS",
    key: "credit_sales_summary_amount_before_enroll",
  },
  {
    label: "Initial OS",
    key: "order_summary_amount_before_enroll",
  },
  {
    label: "Initial Total",
    key: "initial_points",
  },
  {
    label: "Initial Tier",
    key: "initial_tier",
  },
  {
    label: "Enrollment Date",
    key: "Loyalty_Account.created_at",
  },
  {
    label: "Audit Tier",
    key: "overall_tier",
  },
  {
    label: "Annex Tier",
    key: "Loyalty_Account.sales_summary_tier",
  },
  {
    label: "Annex $",
    key: "Loyalty_Account.current_tier_points",
  },
  {
    label: "Tier Diff",
    key: "tier_difference",
  },
  {
    label: "$ Diff",
    key: "dollar_difference",
  },
  {
    label: "Tier Start Date",
    key: "Loyalty_Account.tier_start_date",
  },
  {
    label: "Current OS",
    key: "sales_transaction_amount_after_enroll",
  },
  {
    label: "Current CS",
    key: "credit_sales_amount_after_enroll",
  },
  {
    label: "Current Total",
    key: "total_points",
  },
  {
    label: "Current Tier",
    key: "bumpup_tier",
  },
  {
    label: "Current Run Date",
    key: "run_date",
  },
];
